<template>
    <!-- Main Content -->
    <section class="mb-20 lg:mb-64">
        <div class="flex flex-col lg:flex-row items-center lg:items-start relative gap-12">
            <!-- Background Glow -->
            <div class="absolute -left-10 -top-20 md:-left-20 md:-top-36 w-[300px] h-[300px] md:w-[700px] md:h-[700px] rounded-full blur-[120px] md:blur-[200px] 
             bg-[linear-gradient(121.22deg,rgba(71,209,140,0.25)_0%,rgba(102,163,255,0.25)_100%)]">
            </div>

            <!-- Left Content -->
            <div class="px-4 sm:px-6 lg:px-0 flex-1">
                <!-- Tag -->
                <Tag class="max-w-max py-1 sm:py-2 relative flex overflow-hidden 
                    bg-[image:var(--primary-gradient)] bg-clip-text text-transparent 
                    border-gray-600 rounded-full border 
                    px-3 sm:px-6 text-xs sm:text-base font-medium mb-3 tracking-wide" unstyled>
                    <!-- Glow Circle -->
                    <div class="absolute left-14 sm:left-20 top-3 sm:top-6 
                    w-8 sm:w-20 h-6 sm:h-12 rounded-full 
                    blur-md sm:blur-xl 
                    bg-[linear-gradient(143.9deg,#47D18C,#66A3FF)]"></div>

                    <!-- Content -->
                    <div class="flex items-center gap-1 sm:gap-2 px-1">
                        <NsStarIcon class="w-3 h-3 sm:w-4 sm:h-4" />
                        <span>Features Section</span>
                    </div>
                </Tag>


                <!-- Heading + Paragraph -->
                <div class="space-y-6 sm:space-y-8 mb-6 sm:mb-8">
                    <h1 class="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl max-w-xl font-bold 
                  text-[var(--text-primary)] !leading-[120%]">
                        Supercharge Your E-Commerce with
                        <span class="text-[#47D18C]">Powerful Features</span>
                    </h1>

                    <p class="text-base sm:text-lg lg:text-2xl max-w-2xl leading-relaxed text-[var(--text-primary)]">
                        Transform your store with Nuxt Store's powerful features — seamless integrations,
                        global scalability, and everything you need to grow.
                    </p>
                </div>

                <!-- Button -->
           <Button unstyled iconPos="left" class="group !rounded-lg sm:!rounded-xl !px-4 sm:!px-5 
         bg-[image:var(--primary-gradient)] hover:bg-[image:var(--primary-gradient-reverse)]
         transition-all duration-1000 ease-in-out
         !py-2.5 sm:!py-3 font-semibold
         text-[var(--text-secondary)] 
         flex items-center justify-center gap-2 sm:gap-3 
         w-full sm:w-auto text-sm sm:text-base overflow-hidden z-10 relative">
                        <!-- Icon -->
                        <span class="flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 
           rounded-full bg-white 
           transform transition-all duration-1000 ease-in-out 
           group-hover:translate-x-40">
                            <i class="pi pi-angle-right text-green-500 font-bold text-sm sm:text-lg"></i>
                        </span>

                        <!-- Text -->
                        <span class="transition-all duration-1000 ease-in-out group-hover:-translate-x-10">
                            Explore All Features
                        </span>
                    </Button>
            </div>

            <!-- Right Content - Dashboard Mockup (hidden on smaller screens) -->
            <div class="relative flex-1 hidden lg:block">
                <div class="absolute w-[1050px] h-[1050px] rounded-full -top-[370px] -left-32 border-4"
                    style="border-color: rgba(255, 255, 255, 0.04);"></div>
                <div class="absolute inset-0 m-auto -top-28 left-24 w-[600px] h-[600px] rounded-full"
                    style="box-shadow: 0 0 0 100px rgba(255, 255, 255, 0.04);"></div>

                <NuxtImg width="600" height="412" src="/images/hero-section-image.png" alt="Hero Section Image"
                    class="rounded-2xl max-h-[412px] object-cover" loading="eager"/>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const NsStarIcon = defineAsyncComponent(() =>
    import("~/components/atoms/icons/NsStarIcon.vue")
);
</script>
